import BlockObserver from "./BlockObserver";

export default class GetStarted {
    init(block) {
        this.blockButtons       = block.querySelectorAll('button');
        this.servicesContainer  = block.querySelector('.get-started__services');

        this.loadServices(this.servicesContainer, 'home');

        this.blockButtons && this.blockButtons.forEach((blockButton) => {
            blockButton.addEventListener('click', (event) => {
                this.changeService(blockButton, this.blockButtons);
            });
        });
    }

    changeService(clickedButton, allButtons) {
        allButtons.forEach((button) => {
            button.classList.remove('selected');
            if(button.getAttribute("data-service") === clickedButton.dataset.service) {
                button.classList.add('selected');
                this.loadServices(this.servicesContainer, button.getAttribute("data-service"));
            }
        });
    }

    loadServices(servicesContainer, typeToLoad) {
        servicesContainer.innerHTML = '';

        let formData = new FormData();
        formData.append('current-page', 1);
        formData.append('per-page', -1);
        formData.append('loop', 'services');
        formData.append('buttonType', 'filter-change');
        formData.append('paginationType', 'replace');
        if(servicesContainer.dataset.prefilter) {
            formData.append('typeToLoad', servicesContainer.dataset.prefilter);
        } else {
            formData.append('typeToLoad', typeToLoad);
        }

        fetch('/wp-admin/admin-ajax.php?action=loadPosts', {
            method: 'POST',
            body: formData,
        })
        .then(response => response.json())
        .then(data => {
            if(data['results']?.length) {
                servicesContainer.innerHTML = '';
                data['results'].forEach((result) => {
                    servicesContainer.insertAdjacentHTML('beforeend', result);
                });
            }

			window.app.blockObserver.unmount()
			new BlockObserver(document.querySelectorAll('[data-watch="true"]'))
            return data;
        })
    }
}